import AsyncLoader from '@molecules/AsyncLoader'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  components: {
    AsyncLoader
  },
  computed: {
    ...mapGetters(['reportIsDownloading', 'multipleReportsIsDownloading']),
    ...mapState({
      generatingReport: state => state.reporting.generatingReport,
      reportsLoading: state => state.reporting.reportsLoading,
      reportTypes: state => state.reporting.reportTypes,
      reportingUserMessage: state => state.reporting.reportingUserMessage,
      reportingStatus: state => state.reporting.reportingStatus
    })
  },
  methods: {
    handleFileDownload ({ reportId, type, fileName, invoiceType, downloadKey, dateOfService }) {
      if (!this.reportIsDownloading(reportId)) { this.downloadReport({ reportId, type, fileName, invoiceType, downloadKey, dateOfService }) }
    },
    handleMultipleFileDownload ({ invoiceType, year, month, status, fileName }) {
      return this.downloadMultipleReports({ invoiceType, year, month, status, fileName })
    },
    ...mapActions({
      downloadReport: 'reporting/DOWNLOAD_REPORT',
      downloadMultipleReports: 'reporting/DOWNLOAD_MULTIPLE_REPORTS'
    })
  }
}
